// extracted by mini-css-extract-plugin
export var closeButton = "_lj-1";
export var closeX = "_lj-3";
export var container = "_lj-0";
export var image = "_lj-2";